import { IState, IStore } from '../interfaces/store.interfaces';

import { readonly } from 'vue';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

const store: IStore = {
	state: readonly(state) as IState,
	mutations,
	getters,
	actions,
};

export default store;
